import React, { useEffect, useState } from 'react';
import { NAV_LINKS, OFFER_ANCHOR, PRODUCT, TICKER_ITEMS } from '../data/woodworking';

/** Slim moving ribbon + compact sticky header. */
export function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Four copies per half keep the loop seamless on wide screens.
  const half = [...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS, ...TICKER_ITEMS];
  const track = [...half, ...half];
  return <>
      <div className="marquee overflow-hidden border-b border-white/10 bg-charcoal-cocoa" data-id="element-120" data-mp="25v77q6bjkkv9">
        <p className="sr-only" data-id="element-121" data-mp="3lbpg9kermmls">{TICKER_ITEMS.join(' • ')}</p>
        <div className="animate-marquee flex w-max items-center py-[7px]" aria-hidden data-id="element-122" data-mp="3la4no0c0hdqk">
          {track.map((item, index) => <span key={`${item}-${index}`} className="flex shrink-0 items-center whitespace-nowrap text-[11px] font-semibold uppercase tracking-[0.16em] text-parchment" data-id="element-123" data-mp="3hcgscw6epiy5" data-mpi={index}>
              {item}
              <span className="mx-7 h-1 w-1 rounded-full bg-ember sm:mx-9" data-id="element-124" data-mp="1kwp4o3gfvu3f" />
            </span>)}
        </div>
      </div>

      <header className={`sticky top-0 z-30 border-b transition-colors duration-200 ease-out ${scrolled ? 'border-white/10 bg-charcoal-warm/95 backdrop-blur' : 'border-transparent bg-charcoal-warm'}`} data-id="element-125" data-mp="1pvi976dr0arg">
        <div className="mx-auto flex h-14 w-full max-w-6xl items-center justify-between gap-4 px-5 sm:px-8" data-id="element-126" data-mp="126fuo7eeuy16">
          <a href="#top" className="flex min-h-[44px] items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-olive-pale" aria-label={`${PRODUCT.name} — back to top`} data-id="element-127" data-mp="16ww83ri8ejnj">
            <span className="wordmark flex flex-col text-[0.82rem] text-ivory sm:flex-row sm:gap-[0.4em] sm:text-[0.95rem]" data-id="element-128" data-mp="eftnsjg57jsr">
              <span data-id="element-129" data-mp="1hpy0w612c4hz">Woodworking</span>
              <span className="whitespace-nowrap" data-id="element-130" data-mp="1csxqxk13ehll">
                Furniture Plans<sup className="ml-0.5 font-sans text-[0.55em] font-semibold" data-id="element-131" data-mp="1cqle1la6yxfe">™</sup>
              </span>
            </span>
          </a>

          <nav aria-label="Sections" className="hidden items-center gap-7 lg:flex" data-id="element-132" data-mp="1mhz6xa7n0yzk">
            {NAV_LINKS.map(link => <a key={link.href} href={link.href} className="whitespace-nowrap text-[0.88rem] font-medium text-parchment transition-colors duration-150 ease-out hover:text-ivory focus:outline-none focus-visible:text-olive-pale" data-id="element-133" data-mp="yty2odhhs4py">
                {link.label}
              </a>)}
          </nav>

          <a href={OFFER_ANCHOR} className="hidden min-h-[44px] items-center whitespace-nowrap rounded-[8px] bg-ember px-4 text-[0.8rem] font-bold uppercase tracking-[0.06em] text-white transition-colors duration-150 ease-out hover:bg-ember-deep focus:outline-none focus-visible:ring-4 focus-visible:ring-olive-light/60 sm:inline-flex" data-id="element-134" data-mp="2j8hykop6crxr">
            Get the Collection
          </a>
        </div>
      </header>
    </>;
}